import { useEffect } from "react";

import dayjs from "dayjs";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { getCourseTime } from "../../services/CourseService";


const CourseDetails = ({ school, courseDetails }) => {
  useEffect(() => {}, []);

  return (
    <Table style={{ marginTop: "1em", marginBottom: "1em" }}>
      <Thead>
        <Tr>
          <Th>Course Name</Th>
          <Th>Date</Th>
          <Th>Time</Th>
          <Th>Owner</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>{courseDetails.courseName}</Td>
          <Td>
            {dayjs(courseDetails.date).format("MM/DD")}
          </Td>
          <Td>{getCourseTime(school, courseDetails)}</Td>
          <Td>{courseDetails.last_name}</Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default CourseDetails;
